import React from 'react'
import {
  ContentShare,
  FeaturedRemoteVideos,
  LocalVideo,
  RemoteVideos,
  VideoGrid,
  useContentShareState,
  useFeaturedTileState,
  useLocalVideo,
  useRemoteVideoTileState
} from 'amazon-chime-sdk-component-library-react'

type VideoTileGridProps = {
  layout: 'featured' | 'standard',
  localAttendeeName?: string,
  noRemoteVideoView?: React.ReactNode
}

const fluidStyles = `
  height: 100%;
  width: 100%;
`

const staticStyles = `
  display: flex;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  width: 20vw;
  min-width: 150px;
  max-height: 30vh;
  height: auto;
  border-radius: 5px;
  video {
    border-radius: 5px;
    position: static;
  }
`

export default function VideoTileGrid(props: VideoTileGridProps) {
  const { layout, localAttendeeName, noRemoteVideoView } = props
  const { tileId: contentTileId } = useContentShareState()
  const { tileId: featureTileId } = useFeaturedTileState()
  const { isVideoEnabled } = useLocalVideo()
  const { tiles } = useRemoteVideoTileState()

  const featured = (layout === 'featured' && !!featureTileId) || !!contentTileId
  const remoteSize = tiles.length + (contentTileId ? 1 : 0)
  const gridSize = remoteSize > 1 && isVideoEnabled ? remoteSize + 1 : remoteSize

  return (
    <VideoGrid layout={featured ? 'featured' : 'standard'} size={gridSize}>
      <ContentShare css="grid-area: ft;" />
      {layout === 'featured' ? <FeaturedRemoteVideos /> : <RemoteVideos />}
      <LocalVideo nameplate={localAttendeeName} css={gridSize > 1 ? fluidStyles : staticStyles} />
      {remoteSize === 0 && noRemoteVideoView}
    </VideoGrid>
  )
}